// src/pages/exercise/components/UI/SelectionUI.jsx
import { useStore } from '../Stores/exerciseStore';
import { CHARACTER_CONFIG } from '../../data/characterConfig';
import './SelectionUI.css';

export function SelectionUI() {
  const { phase, nextChar, prevChar, charIndex } = useStore();

  if (phase !== 'SELECTION') return null;

  const config = CHARACTER_CONFIG[charIndex];
  const isMobile = window.innerWidth <= 768;

  const handleStart = () => {
    const { scrollLocked, triggerTransition1 } = useStore.getState();
    if (!scrollLocked) triggerTransition1();
  };

  return (
    <>
      {/* ── Character Title Block ── */}
      <div className="sel-title-block">
        <h1 className="sel-char-name">{config.name}</h1>
        <p
          className="sel-char-mood"
          style={{
            color: config.accentColor,
            textShadow: `0 2px 12px rgba(0,0,0,0.55), 0 0 18px ${config.accentColor}99`
          }}
        >
          {config.moodToken}
        </p>
      </div>

      {/* ── Left Arrow ── */}
      <button
        className="sel-arrow-btn left"
        onClick={prevChar}
        aria-label="Previous character"
      >
        <svg viewBox="0 0 24 24">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      {/* ── Right Arrow ── */}
      <button
        className="sel-arrow-btn right"
        onClick={nextChar}
        aria-label="Next character"
      >
        <svg viewBox="0 0 24 24">
          <polyline points="9 6 15 12 9 18" />
        </svg>
      </button>

      {/* ── Scroll Cue / Mobile Start Button ── */}
      {isMobile ? (
        <button className="sel-scroll-cue sel-start-btn" onClick={handleStart}>
          <span className="sel-scroll-label">Tap to Start</span>
          <div className="sel-down-arrow">
            <svg viewBox="0 0 72 24">
              <polyline points="6 9 36 20 66 9" />
            </svg>
          </div>
        </button>
      ) : (
        <div className="sel-scroll-cue">
          <span className="sel-scroll-label">Scroll to Start</span>
          <div className="sel-down-arrow">
            <svg viewBox="0 0 72 24">
              <polyline points="6 9 36 20 66 9" />
            </svg>
          </div>
        </div>
      )}
    </>
  );
}